"use strict";

exports.__esModule = true;
exports.TimeAggregationSelection = void 0;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TimeAggregationSelection = exports.TimeAggregationSelection = function TimeAggregationSelection(props) {
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    style: {
      marginBottom: "10px"
    },
    itemPredicate: function itemPredicate(query, item) {
      return new RegExp(query).test(item.label);
    },
    getKey: function getKey(item) {
      return item.name;
    },
    selected: element.props.dateHistogram,
    onSelect: function onSelect(item) {
      if (item && item.length) {
        elementEditor.setProp(path, "dateHistogram", [item[0].name]);
      }
    },
    items: _timeAggregationBinMapping.timeGrouping,
    renderItemText: function renderItemText(item) {
      return item.label;
    }
  });
};